import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface Datamatrix {
  base64: string;
  prefix: string;
}

/**
 * Datamatrix INS d'un patient, généré par le back Hypermed.
 * Indépendant des stratégies INSi (websocket / API REST) : simple appel au back.
 */
@Injectable({
  providedIn: 'root'
})
export class InsDatamatrixService {

  private apiUri = environment.basePath + '/patient/ins/';

  constructor(private _http: HttpClient) { }

  async getPatientDatamatrix(patientId: string): Promise<Datamatrix | undefined> {
    if (environment.mock) {
      return undefined;
    }
    return this._http.get<Datamatrix | undefined>(`${this.apiUri}patient-datamatrix/${patientId}`).toPromise();
  }
}
